import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { api } from '../api/client';
import type { AuthUser, AuthUserRole } from '../types/reunion';

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  roles: AuthUserRole[];
  isAuthenticated: boolean;

  setAuth: (token: string, user: AuthUser, roles: AuthUserRole[]) => void;
  clearAuth: () => void;
  updateUser: (updates: Partial<AuthUser>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      roles: [],
      isAuthenticated: false,

      setAuth: (token, user, roles) => {
        api.setToken(token);
        set({ token, user, roles, isAuthenticated: true });
      },

      clearAuth: () => {
        api.setToken(null);
        set({ token: null, user: null, roles: [], isAuthenticated: false });
      },

      updateUser: (updates) => {
        const current = get().user;
        if (current) {
          set({ user: { ...current, ...updates } });
        }
      },
    }),
    {
      name: 'reunion-auth',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        roles: state.roles,
        isAuthenticated: state.isAuthenticated,
      }),
      onRehydrateStorage: () => {
        return (rehydratedState) => {
          if (rehydratedState?.token) {
            api.setToken(rehydratedState.token);
          }
        };
      },
    }
  )
);
